import { useTranslation } from 'react-i18next';

import { UseMutationResult } from '@tanstack/react-query';

import { ErrorDisplay } from '../../../../Shared/components/ErrorDisplay/ErrorDisplay';
import { ApiError } from '../../../../Shared/interfaces/ApiError';
import { CustomConfirmationModal } from '../../../../UiComponentsLibrary/CustomConfirmationModal';
import { LeftAlignedErrorContainer } from '../UserManagement.styles';

interface UserActionModalWrapperProps {
  deleteModal: boolean;
  setDeleteModal: React.Dispatch<React.SetStateAction<boolean>>;
  userId?: string;
  deleteUserMutation: UseMutationResult<
    any,
    ApiError,
    { userId: string; successMessage: string },
    unknown
  >;
}

const UserActionModalWrapper = ({
  deleteModal,
  setDeleteModal,
  userId,
  deleteUserMutation,
}: UserActionModalWrapperProps) => {
  const { t } = useTranslation();
  return (
    <CustomConfirmationModal
      isOpen={deleteModal}
      title={t('delete-user-modal-label')}
      message={t('delete-user-modal-confirmation-message', {
        userId: userId,
      })}
      onConfirmCb={() => {
        if (userId) {
          deleteUserMutation.mutate({
            userId,
            successMessage: t('user-deleted-success-message'),
          });
        }
      }}
      onCancelCb={() => {
        deleteUserMutation.reset();
        setDeleteModal(false);
      }}
      confirmButtonText={
        deleteUserMutation.isPending
          ? t('delete-user-modal-button-loading-text')
          : t('delete-user-modal-label')
      }
      confirmButtonDisabled={deleteUserMutation.isPending}
    >
      {deleteUserMutation.isError && (
        <LeftAlignedErrorContainer>
          <ErrorDisplay error={deleteUserMutation.error as ApiError} />
        </LeftAlignedErrorContainer>
      )}
    </CustomConfirmationModal>
  );
};

export default UserActionModalWrapper;
